import en from "./en";
import da from "./da";
import pl from "./pl";

const languages = {
  en,
  da,
  pl,
};

const getCopy = (lang = "en") => languages[lang] || en;

export default getCopy;